import {connect} from 'react-redux';
import BaseTab from './BaseTab';

class TicketsTab extends BaseTab {


}
const mapStateToProps = state => {
	return {
    data: state.transactionsTickets,
  };
};



export default connect(mapStateToProps, null)(TicketsTab);